import { Mail } from 'lucide-react';
import { content } from '../content';

const PricingContact = ({ onOpenConsultation }) => {
  return (
    <section id="contact" className="py-20 lg:py-28 bg-[#FCF9F5]">
      <div className="max-w-5xl mx-auto px-6 lg:px-12">
        {/* Pricing */}
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl serif font-light text-gray-900 mb-6">
            {content.pricing.heading}
          </h2>
          <p className="text-xl text-gray-600 mb-4 leading-relaxed">
            {content.pricing.paragraph1}
          </p>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            {content.pricing.paragraph2}
          </p>
          <button
            onClick={onOpenConsultation}
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white px-12 py-6 text-lg rounded-lg transition-all duration-300 hover:shadow-lg font-medium cursor-pointer"
            data-testid="pricing-cta-btn"
          >
            {content.pricing.buttonText}
          </button>
        </div>

        {/* Contact Info */}
        <div className="mt-20 bg-white rounded-2xl p-10 shadow-sm border border-gray-200">
          <h3 className="text-3xl serif font-light text-gray-900 mb-8 text-center">
            {content.pricing.contactHeading}
          </h3>
          
          {/* Logo and Email side by side */}
          <div className="flex items-center justify-center space-x-8 mb-6">
            <img 
              src="/images/heise-wellness-logo.png" 
              alt="Heise Wellness" 
              className="h-28 lg:h-32 w-auto"
            />
            <div className="flex items-center space-x-3 text-gray-700">
              <Mail className="text-purple-600" size={24} />
              <a
                href={`mailto:${content.pricing.email}`}
                className="text-lg hover:text-purple-600 transition-colors duration-300"
              >
                {content.pricing.email}
              </a>
            </div>
          </div>
          
          <p className="text-center text-gray-600 text-sm">
            {content.pricing.confidentialityNote}
          </p>

          {/* Partnerships */}
          <div className="mt-12 pt-10 border-t border-gray-200">
            <h4 className="text-2xl serif font-light text-gray-900 mb-4 text-center">
              {content.pricing.partnershipsHeading}
            </h4>
            <p className="text-gray-600 text-center leading-relaxed mb-6">
              {content.pricing.partnershipsDescription}
            </p>
            <div className="text-center">
              <a
                href={`mailto:${content.pricing.email}?subject=Partnership Inquiry`}
                className="text-purple-600 hover:text-purple-700 font-medium transition-colors duration-300"
              >
                {content.pricing.partnershipsLinkText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingContact;
